// extracted by mini-css-extract-plugin
module.exports = {"Day":"ActivitiesTab_Day__Mx40K","ActiveDay":"ActivitiesTab_ActiveDay__1HyX7","ProgressValue":"ActivitiesTab_ProgressValue__1x1NQ"};